<template>
  <div id="order">
    <div class="hero">
      <!-- <img class="bgimag" src="../assets/Order/Order-background.png" alt=""> -->
      <div class="OderHero">
        <h1>Are you looking to:</h1>
        <div class="buttonsSection">
          <button @click="scrollTo('subscribe')" class="subscribe-button">
            Subscribe
          </button>
          <button @click="scrollTo('orderOnDemand')" class="order-button">
            Order On-Demand
          </button>
        </div>
      </div>
    </div>
    <div class="subscribeSection">
      <div class="headingSection" id="subscribe">
        <h1>Subscribe</h1>
        <p>
          Fill out the form to customize your milk plan and submit to begin your
          subscription.
        </p>
      </div>
      <div class="DecideSection">
        <h1>1. Decide It</h1>
        <p>Membership Period:</p>
        <div class="buttonsSection">
          <button
            class="SelectiveBtn"
            @click="getAnnual(), scrollTo('setIt')"
            id="annual"
            value="annual"
          >
            Annual
          </button>
          <button
            class="SelectiveBtn"
            @click="getMonthly(), scrollTo('setIt')"
            id="monthly"
            value="monthly"
          >
            Monthly
          </button>
        </div>
      </div>
      <div class="SetItSection" id="setIt">
        <h1>2. Set It</h1>
        <p>Delivery Plan:</p>
        <div class="buttonsSection">
          <button
            class="SelectiveBtn"
            @click="getDailyPlan(), scrollTo('liters')"
            id="daily"
            value="daily"
          >
            Daily
          </button>
          <button
            class="SelectiveBtn"
            @click="getWeeklyPlan(), scrollTo('liters')"
            id="weekly"
            value="weekly"
          >
            Weekly
          </button>
          <button
            class="SelectiveBtn"
            @click="getCustomPlan()"
            id="custom"
            value="custom"
          >
            Custom
          </button>
        </div>
      </div>
      <Calendar id="calendar2" />
      <hr />
      <div class="Liters" id="liters">
        <p>Number of litres per delivery:</p>
        <div class="counter">
          <div class="InnerCounter">
            <button type="button" v-on:click="decreaseAge">
              <img src="../assets/icons/minus-button.png" />
            </button>
            <h1>{{ counterLiters }} Liters</h1>
            <button type="button" v-on:click="increaseAge">
              <img src="../assets/icons/plus-button.png" />
            </button>
          </div>
        </div>
      </div>
      <hr />
      <div class="GetItSection">
        <p>Choose your schedule:</p>
        <div class="buttonsSection">
          <button
            class="SelectiveBtn"
            @click="getMorningCycle(),scrollTo('getIt')"
            id="morning"
            value="morning"
          >
            Morning Cycle <br />
            (5am-8am)
          </button>
          <button
            class="SelectiveBtn"
            @click="getEveningCycle(),scrollTo('getIt')"
            id="evening"
            value="evening"
          >
            Evening Cycle <br />
            (5pm-8pm)
          </button>
        </div>
      </div>
      <div class="GetItSection" id="getIt">
        <h1>3. Get It</h1>
        <p>When do you want to start?</p>
        <div class="buttonsSection">
          <button class="SelectiveBtn" id="everyday" @click="getDaily(),scrollTo('info')" value="today">Daily</button>
        </div>
        <div class="buttonsSection">
          <button class="SelectiveBtn" id="pickdate" @click="getDatePick()">Pick Date</button>
        </div>
          <v-row id="whenToStart">
            <v-date-picker v-model="picker"></v-date-picker>
          </v-row>
      </div>
      <div class="Info" id="info">
        <button
          class="SelectiveBtn"
          @click="getIndividual()"
          id="individual"
          value="individual"
        >
          Individual /<br />Household
        </button>
        <button
          class="SelectiveBtn"
          @click="getEnterprise()"
          id="enterprises"
          value="enterprises"
        >
          Corporate /<br />Enterprise
        </button>
        <form action="">
          <div class="buttonsSection"></div>
          <table>
            <tr>
              <td>
                <input
                  type="text"
                  name=""
                  placeholder="Corporate/Enterprise Name"
                />
              </td>
            </tr>
            <tr>
              <td>
                <input type="text" name="" placeholder="Name" />
              </td>
            </tr>
            <tr>
              <td>
                <input type="text" name="" placeholder="Phone Number" />
              </td>
            </tr>
            <tr>
              <td>
                <input type="text" name="" placeholder="Email (optional)" />
              </td>
            </tr>
            <tr>
              <td>
                <input type="text" name="" placeholder="Address" />
              </td>
            </tr>
          </table>
          <div class="formPrice">
            <p>Total:</p>
            <h1>{{ this.SubscriptionResults() }}</h1>
          </div>
          <div class="buttonsSection" id="buttonsSection">
            <button class="subscribe">Subscribe</button>
          </div>
        </form>
      </div>
    </div>
    <OrderOnDemand />
    <Footer />
  </div>
</template>

<script>
import OrderOnDemand from "../components/OrderOnDemand.vue";
import Calendar from "../components/Calendar.vue";
import Footer from "../components/layouts/Footer.vue";
export default {
  components: {
    OrderOnDemand,
    Calendar,
    Footer,
  },
  data() {
    return {
      counterLiters: 2,
      picker: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10),
    };
  },
  methods: {
    SubscriptionResults(){
      var total = 1000 *this.counterLiters
      return total
    },
    //  getAnnual(id) {
    //   var element = document.getElementById(id);
    //   console.log(element.value);
    //   if (element.value == "annual" ) {
    //     element.style.backgroundColor = "#06D6A0";
    //     element.style.color = "#fff";
    //     element.style.border = "none";
    //   }else if(element.value == "monthly"){
    //     element.style.backgroundColor = "#06D6A0";
    //     element.style.border = "none";
    //     element.style.color = "#fff";
    //   }
    // },
    getAnnual() {
      var Varannual = document.getElementById("annual");
      var Varmonthly = document.getElementById("monthly");
      console.log(Varannual.value);
      if (Varannual.value) {
        Varmonthly.style.backgroundColor = "inherit";
        Varannual.style.backgroundColor = "#06D6A0";
        Varannual.style.color = "#fff";
        Varannual.style.border = "none";
        Varmonthly.style.color = "unset";
        Varmonthly.style.border = "2px Solid #343540";
      }
    },
    getMonthly() {
      var Varannual = document.getElementById("annual");
      var Varmonthly = document.getElementById("monthly");
      console.log(Varmonthly.value);
      if (Varannual.value) {
        Varmonthly.style.backgroundColor = "#06D6A0";
        Varannual.style.backgroundColor = "inherit";
        Varannual.style.color = "unset";
        Varannual.style.border = "2px Solid #343540";
        Varmonthly.style.color = "#fff";
        Varmonthly.style.border = "none";
      }
    },
    getDailyPlan() {
      var Vardaily = document.getElementById("daily");
      var Varweekly = document.getElementById("weekly");
      var Varcustom = document.getElementById("custom");
      console.log(Vardaily.value);
      if (document.getElementById("calendar2").style.display == "unset") {
        document.getElementById("calendar2").style.display = "none";
      }
      if (Vardaily.value) {
        Varweekly.style.backgroundColor = "inherit";
        Vardaily.style.backgroundColor = "#06D6A0";
        Varcustom.style.backgroundColor = "inherit";
        Vardaily.style.color = "#fff";
        Vardaily.style.border = "none";
        Varweekly.style.color = "unset";
        Varweekly.style.border = "2px Solid #343540";
        Varcustom.style.color = "unset";
        Varcustom.style.border = "2px Solid #343540";
      }
    },
    getWeeklyPlan() {
      var Vardaily = document.getElementById("daily");
      var Varweekly = document.getElementById("weekly");
      var Varcustom = document.getElementById("custom");
      console.log(Varweekly.value);
      if (document.getElementById("calendar2").style.display == "unset") {
        document.getElementById("calendar2").style.display = "none";
      }
      if (Vardaily.value) {
        Varweekly.style.backgroundColor = "#06D6A0";
        Vardaily.style.backgroundColor = "inherit";
        Varcustom.style.backgroundColor = "inherit";
        Vardaily.style.color = "unset";
        Vardaily.style.border = "2px Solid #343540";
        Varweekly.style.color = "#fff";
        Varweekly.style.border = "none";
        Varcustom.style.color = "unset";
        Varcustom.style.border = "2px Solid #343540";
      }
    },
    getCustomPlan() {
      var Vardaily = document.getElementById("daily");
      var Varweekly = document.getElementById("weekly");
      var Varcustom = document.getElementById("custom");
      document.getElementById("calendar2").style.display = "unset";
      console.log(Varcustom.value);
      if (Varcustom.value) {
        Varcustom.style.backgroundColor = "#06D6A0";
        Vardaily.style.backgroundColor = "inherit";
        Vardaily.style.color = "unset";
        Vardaily.style.border = "2px Solid #343540";
        Varcustom.style.color = "#fff";
        Varcustom.style.border = "none";
        Varweekly.style.color = "unset";
        Varweekly.style.border = "2px Solid #343540";
        Varweekly.style.backgroundColor = "unset";
      }
    },
    getMorningCycle() {
      var Varannual = document.getElementById("morning");
      var Varmonthly = document.getElementById("evening");
      console.log(Varannual.value);
      if (Varannual.value) {
        Varmonthly.style.backgroundColor = "inherit";
        Varannual.style.backgroundColor = "#06D6A0";
        Varannual.style.color = "#fff";
        Varannual.style.border = "none";
        Varmonthly.style.color = "unset";
        Varmonthly.style.border = "2px Solid #343540";
      }
    },
    getEveningCycle() {
      var Varannual = document.getElementById("morning");
      var Varmonthly = document.getElementById("evening");
      console.log(Varmonthly.value);
      if (Varannual.value) {
        Varmonthly.style.backgroundColor = "#06D6A0";
        Varannual.style.backgroundColor = "inherit";
        Varannual.style.color = "unset";
        Varannual.style.border = "2px Solid #343540";
        Varmonthly.style.color = "#fff";
        Varmonthly.style.border = "none";
      }
    },
    getIndividual() {
      var Varannual = document.getElementById("individual");
      var Varmonthly = document.getElementById("enterprises");
      console.log(Varannual.value);
      if (Varannual.value) {
        Varmonthly.style.backgroundColor = "inherit";
        Varannual.style.backgroundColor = "#06D6A0";
        Varannual.style.color = "#fff";
        Varannual.style.border = "none";
        Varmonthly.style.color = "unset";
        Varmonthly.style.border = "2px Solid #343540";
      }
    },
    getEnterprise() {
      var Varannual = document.getElementById("individual");
      var Varmonthly = document.getElementById("enterprises");
      console.log(Varmonthly.value);
      if (Varannual.value) {
        Varmonthly.style.backgroundColor = "#06D6A0";
        Varannual.style.backgroundColor = "inherit";
        Varannual.style.color = "unset";
        Varannual.style.border = "2px Solid #343540";
        Varmonthly.style.color = "#fff";
        Varmonthly.style.border = "none";
      }
    },
    getDaily(){
      var everyday = document.getElementById("everyday");
      var datePicked = document.getElementById("pickdate");
      console.log(everyday.value);
      if (everyday.value == "today") {
        everyday.style.backgroundColor = "#06D6A0";
        datePicked.style.backgroundColor = "inherit";
        datePicked.style.color = "unset";
        datePicked.style.border = "2px Solid #343540";
        everyday.style.color = "#fff";
        everyday.style.border = "none";
      document.getElementById("whenToStart").style.display="none"
      }
    },
    getDatePick(){
      var everyday = document.getElementById("everyday");
      var datePicked = document.getElementById("pickdate");
      if (everyday.value == "today") {
        datePicked.style.backgroundColor = "#06D6A0";
        everyday.style.backgroundColor = "inherit";
        everyday.style.color = "unset";
        everyday.style.border = "2px Solid #343540";
        datePicked.style.color = "#fff";
        datePicked.style.border = "none";
        document.getElementById("whenToStart").style.display="unset"
      }
    },

    decreaseAge() {
      if (this.counterLiters > 0) {
        this.counterLiters--;
      }
    },
    increaseAge() {
      this.counterLiters++;
    },
    scrollTo(id) {
      const element = document.getElementById(id);
      element.scrollIntoView({ behavior: "smooth" });
    },
    updateScroll() {
      this.scrollPosition = window.scrollY;
    },
  },
};
</script>

<style scoped>
.hero {
  /* position: relative; */
  background-image: url("../assets/Order/Order-background-About.png");
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
  height: 750px;
  /* display: grid;
  place-items: center; */
}
.counter {
  display: grid;
  /* place-items: center; */
  height: 150px;
}
#calendar2 {
  display: none;
}
#whenToStart{
  display: none;

}
.subscribe {
  margin: auto;
  color: #fff;
  height: 60px;
  width: 250px;
  border-radius: 60px;
  background-color: #0077b6;
}
.InnerCounter {
  text-align: center;
  display: flex;
  color: #343540;
}
.InnerCounter button {
  width: unset;
}
.subscribe-btn {
  display: grid;
  place-items: center;
}
.subscribe-btn button {
  /* margin: auto; */
  color: #fff;
  height: 60px;
  width: 250px;
  border-radius: 60px;
  background-color: #0077b6;
}
.InnerCounter h1 {
  padding-top: 20px;
  margin: 10px;
  color: #343540;
}
.subscribeSection {
  width: 90%;
  margin: auto;
}

form {
  position: relative;
}
table {
  width: 100%;
}
.formPrice {
  position: absolute;
  bottom: 30px;
  right: 30px;
}
.formPrice h1 {
  margin: unset;
  color: #343540;
  font-size: 26px;
  font-weight: 500;
}
h1 {
  margin-bottom: 50px;
  color: #fff;
  font-family: "DM Sans";
  font-size: 36px;
  font-weight: 700;
  line-height: 47px;
  text-align: center;
}
form input {
  padding: 10px;
  margin-top: 20px;
  box-sizing: border-box;
  height: 40px;
  width: 438px;
  border-radius: 30px;
  border: 1px solid #343540;
}
.headingSection h1 {
  color: #343540;
  font-family: "DM Sans";
  text-align: left;
  font-size: 36px;
  font-weight: 700;
  line-height: 47px;
}
.headingSection,
.DecideSection,
.SetItSection,
.GetItSection {
  display: grid;
  place-items: left;
}
.headingSection p,
.DecideSection p,
.SetItSection p,
.GetItSection p {
  max-width: 300px;
  color: #343540;
  font-family: "DM Sans";
  font-size: 14px;
  line-height: 18px;
}

/* ############################# */
button.SelectiveBtn {
  border: 2px solid #343540;
  color: #343540;
}

.order-button {
  background-color: #fff;
  color: #0077b6;
}

/* ############################### */

.DecideSection h1,
.SetItSection h1,
.GetItSection h1 {
  color: #343540;
  font-family: "DM Sans";
  font-size: 26px;
  font-weight: 500;
  line-height: 34px;
  text-align: left;
}
.OderHero {
  padding-top: 100px;
}
.OderHero .buttonsSection {
  display: flex;
  justify-content: center;
}
.buttonsSection {
  flex-wrap: wrap;
  display: flex;
  justify-content: start;
}
#buttonsSection{
  margin-top: 50px;
}
.dateInput button {
  border: none;
}
.SelectiveBtn input {
  border: 2px solid #343540;
  height: 60px;
  width: 220px;
  border-radius: 60px;
  padding: 10px;
}
button {
  box-sizing: border-box;
  border-radius: 60px;
  height: 60px;
  width: 220px;
  border: unset;
  font-size: 20px;
  font-weight: 500;
  line-height: 26px;
  text-align: center;
  background-color: transparent;
  margin: 30px 30px 30px 0px;
}
.subscribe-button {
  border: 2px solid #fff;
  color: #fff;
  /* color: #0077B6; */
}
.order-button {
  background-color: #fff;
  color: #0077b6;
}
@media screen and (max-width: 720px) {
  form input {
    width: 100%;
  }
  .formPrice {
    position: unset;
  }
}
</style>